/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { IWithCaseManagementNoteDto } from '../comments/models/iwith-case-management-note-dto.interface';
import { ICommentableDto } from '../comments/models/icommentable-dto.interface';
import { IWithFinancialsNoteDto } from '../comments/models/iwith-financials-note-dto.interface';
import { ActorMailRecipientDto } from './actor-mail-recipient-dto';
import { ActorTypes } from '../enums/actor-types.enum';
import { CommentDto } from '../comments/models/comment-dto';

//<custom-head>
import { Translations } from 'app/translations';
import { ImportExportCountry } from 'api/enums';
import { EnumUtils } from 'app/enum-utils';
//</custom-head>

export class ActorDto implements IWithCaseManagementNoteDto, ICommentableDto, IWithFinancialsNoteDto {
  public id: string = undefined;
  public customerId: string = undefined;
  public name: string = undefined;
  public isCustomer: boolean;
  public organizationNumber: string = undefined;
  public address: string = undefined;
  public postCode: string = undefined;
  public city: string = undefined;
  public country: string = undefined;
  public countryCode: string = undefined;
  public tollCredit: string = undefined;
  public hasInvoiceMailRecipient: boolean;
  public hasImportMailRecipient: boolean;
  public hasExportMailRecipient: boolean;
  public hasTollCredit: boolean;
  public eoriNumber: string = undefined;
  public isExternallyAvailable: boolean;
  public mailRecipients: ActorMailRecipientDto[];
  public contactName: string = undefined;
  public contactPhoneNumber: string = undefined;
  public contactEmail: string = undefined;
  public declareVat: boolean;
  public type: ActorTypes;
  public senderApprovedUtc: Date | string;
  public senderApprovedBy: string = undefined;
  public receiverApprovedUtc: Date | string;
  public receiverApprovedBy: string = undefined;
  public invoiceApprovedUtc: Date | string;
  public invoiceApprovedBy: string = undefined;
  public declarationApprovedUtc: Date | string;
  public declarationApprovedBy: string = undefined;
  public automaticMeasures: string[];
  public needsApproval: boolean;
  public comments: CommentDto[];
  public financialsNote: string = undefined;
  public caseManagementNote: string = undefined;
  public erpCustomerConnectionId: string = undefined;

  //<custom-body>
  public constructor(source: ActorDto) {
    Object.assign(this, source);
  }

  // tslint:disable:no-bitwise
  get isSender(): boolean {
    return (this.type & ActorTypes.Sender) === ActorTypes.Sender;
  }

  get isReceiver(): boolean {
    return (this.type & ActorTypes.Receiver) === ActorTypes.Receiver;
  }

  get isSeller(): boolean {
    return (this.type & ActorTypes.Seller) === ActorTypes.Seller;
  }

  get isBuyer(): boolean {
    return (this.type & ActorTypes.Buyer) === ActorTypes.Buyer;
  }

  get isInvoice(): boolean {
    return (this.type & ActorTypes.Invoice) === ActorTypes.Invoice;
  }

  get isDeclarant(): boolean {
    return (this.type & ActorTypes.Declarant) === ActorTypes.Declarant;
  }
  get isDelegate(): boolean {
    return (this.type & ActorTypes.Delegate) === ActorTypes.Delegate;
  }

  get isExporter(): boolean {
    return (this.type & ActorTypes.Exporter) === ActorTypes.Exporter;
  }

  get isImporter(): boolean {
    return (this.type & ActorTypes.Importer) === ActorTypes.Importer;
  }

  get isConsolidator(): boolean {
    return (this.type & ActorTypes.Consolidator) === ActorTypes.Consolidator;
  }

  get isShipper(): boolean {
    return (this.type & ActorTypes.Shipper) === ActorTypes.Shipper;
  }

  get isManufacturer(): boolean {
    return (this.type & ActorTypes.Manufacturer) === ActorTypes.Manufacturer;
  }

  get isWarehouseOwner(): boolean {
    return (this.type & ActorTypes.WarehouseOwner) === ActorTypes.WarehouseOwner;
  }

  get isGuarantee(): boolean {
    return (this.type & ActorTypes.Guarantee) === ActorTypes.Guarantee;
  }

  get isCustomsPayer(): boolean {
    return (this.type & ActorTypes.CustomsPayer) === ActorTypes.CustomsPayer;
  }
  // tslint:enable:no-bitwise

  public get hasTollCreditNo(): boolean {
    return this.countryCode === 'NO'
      && this.tollCredit != null
      && this.tollCredit !== '';
  }

  public get isValid(): boolean {
    // FIXME: Bring back organizationNumber check for some countries
    // && this.organizationNumber != null && this.organizationNumber > 0
    // tslint:disable-next-line:max-line-length
    // https://trello.com/c/DD6ArJHi/67-vissa-utl%C3%A4ndska-kunder-beh%C3%B6ver-vi-inte-ha-orgnr-p%C3%A5-l%C3%A4mna-blankt-ist%C3%A4llet-f%C3%B6r-0

    return !!this.name
        && !!this.address
        && !!this.postCode
        && !!this.city
        && !!this.countryCode;
  }

  public get errors(): string {
    const errors = [];

    if (this.isValid)
      return null;

    if (!this.name)
      errors.push(Translations.ClearanceCaseValidationError.MissingSenderRecipientName);

    if (!this.address)
      errors.push(Translations.ClearanceCaseValidationError.MissingSenderRecipientAddress);

    if (!this.postCode)
      errors.push(Translations.ClearanceCaseValidationError.MissingSenderRecipientPostCode);

    if (!this.city)
      errors.push(Translations.ClearanceCaseValidationError.MissingSenderRecipientCity);

    if (!this.countryCode)
      errors.push(Translations.ClearanceCaseValidationError.MissingSenderRecipientCountry);

    return errors.join(', ');
  }

  public get validAsSender(): boolean { return this.isSender  && !!this.senderApprovedUtc; }
  public get validAsRecipient(): boolean { return this.isReceiver && !!this.receiverApprovedUtc; }
  public get validAsInvoiceRecipient(): boolean { return this.isInvoice && !!this.invoiceApprovedUtc; }
  public get validAsDeclarant(): boolean { return this.isDeclarant && !!this.declarationApprovedUtc; }

  public get eoriHasCountryCode(): boolean {
    if (!this.eoriNumber || this.eoriNumber === '') {
      // Ignore if there is no EORI number.
      return true;
    }

    // Make sure the EORI number starts with a country code
    return /^[a-zA-Z]{2}.+/.test(this.eoriNumber);
  }

  public get types(): ActorTypes[] {
    return [
      ActorTypes.Sender,
      ActorTypes.Receiver,
      ActorTypes.Invoice,
      ActorTypes.Declarant,
      ActorTypes.Delegate,
      ActorTypes.Exporter,
      ActorTypes.Importer,
      ActorTypes.Seller,
      ActorTypes.Buyer,
      ActorTypes.Consolidator,
      ActorTypes.Shipper,
      ActorTypes.Manufacturer,
      ActorTypes.WarehouseOwner,
      ActorTypes.Guarantee,
      ActorTypes.CustomsPayer,
    ].filter(t => EnumUtils.hasFlag(this.type, t));
  }

  public validOrgnr(country: ImportExportCountry): boolean {
    const onlyDigitsPattern = new RegExp(/^\d+$/);
    switch (country) {
      case ImportExportCountry.Sweden:
      case ImportExportCountry.SwedenEu:
        return this.organizationNumber && onlyDigitsPattern.test(this.organizationNumber);
      default:
        return true;
    }
  }

  public validContact(country: ImportExportCountry): boolean {
    switch (country) {
      case ImportExportCountry.Sweden:
      case ImportExportCountry.SwedenEu:
        return !!this.contactName && !!this.contactPhoneNumber;
      default:
        return true;
    }
  }
  //</custom-body>
}
